/* BeadznThreadz premium header: announcement, sticky header, mega menu, search overlay. */
(function () {
  if (window.__bzHeaderLoaded) return;
  window.__bzHeaderLoaded = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const desktopMQ = window.matchMedia('(min-width: 990px)');

  /* ================= Announcement ================= */
  class BzAnnouncement extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.bz-announce__slide')];
      this.index = 0;
      if (this.slides.length < 2) return;
      this.querySelectorAll('.bz-announce__arrow').forEach((btn) =>
        btn.addEventListener('click', () => {
          this.go(this.index + Number(btn.dataset.dir));
          this.restart();
        })
      );
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      this.start();
    }
    disconnectedCallback() {
      this.stop();
    }
    go(i) {
      const n = this.slides.length;
      this.slides[this.index].classList.remove('is-active');
      this.slides[this.index].setAttribute('aria-hidden', 'true');
      this.index = (i + n) % n;
      this.slides[this.index].classList.add('is-active');
      this.slides[this.index].removeAttribute('aria-hidden');
    }
    start() {
      if (this.dataset.autoplay !== 'true' || reduceMotion) return;
      this.stop();
      this.timer = setInterval(() => this.go(this.index + 1), Number(this.dataset.speed) || 5000);
    }
    stop() {
      clearInterval(this.timer);
    }
    restart() {
      this.stop();
      this.start();
    }
  }
  if (!customElements.get('bz-announcement')) customElements.define('bz-announcement', BzAnnouncement);

  /* ================= Header ================= */
  class BzHeader extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section') || this;
      this.items = [...this.querySelectorAll('[data-bz-nav-item]')];
      this.trigger = this.dataset.megaTrigger || 'hover';
      this.openItem = null;
      this.lastY = window.scrollY;

      this.setHeight = this.setHeight.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.onDocClick = this.onDocClick.bind(this);
      this.onKey = this.onKey.bind(this);

      this.setHeight();
      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(this.setHeight);
        this.ro.observe(this);
      } else {
        window.addEventListener('resize', this.setHeight);
      }

      if (this.dataset.sticky !== 'none') {
        this.section.classList.add('bz-hdr-sticky');
        if (this.dataset.sticky === 'always') this.section.classList.add('bz-hdr-sticky--always');
        window.addEventListener('scroll', this.onScroll, { passive: true });
      }

      this.initMega();
      document.addEventListener('click', this.onDocClick);
      document.addEventListener('keydown', this.onKey);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      document.removeEventListener('click', this.onDocClick);
      document.removeEventListener('keydown', this.onKey);
      if (this.ro) this.ro.disconnect();
    }

    setHeight() {
      const announce = document.querySelector('.bz-announce-section');
      const h = Math.round(this.getBoundingClientRect().height);
      document.documentElement.style.setProperty('--header-height', `${h}px`);
      document.documentElement.style.setProperty('--bz-header-h', `${h}px`);
      if (announce) document.documentElement.style.setProperty('--bz-announce-h', `${Math.round(announce.getBoundingClientRect().height)}px`);
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        const y = window.scrollY;
        const past = y > this.offsetHeight + 40;
        this.section.classList.toggle('bz-scrolled', y > 8);
        if (this.dataset.sticky === 'on-scroll-up' && !this.isSearchOpen()) {
          if (y > this.lastY && past) {
            if (!this.section.classList.contains('bz-hidden')) {
              this.section.classList.add('bz-hidden');
              this.closeMega();
            }
          } else if (y < this.lastY - 4) {
            this.section.classList.remove('bz-hidden');
          }
        }
        this.lastY = y;
        this.ticking = false;
      });
    }

    isSearchOpen() {
      const s = document.getElementById('BzSearch');
      return s && !s.hidden;
    }

    /* ---- Mega menu ---- */
    initMega() {
      this.items.forEach((item) => {
        const link = item.querySelector('.bz-nav__link');
        const panel = item.querySelector('[data-bz-mega]');
        if (!panel) return;

        if (this.trigger === 'hover') {
          item.addEventListener('pointerenter', (e) => {
            if (e.pointerType !== 'mouse' || !desktopMQ.matches) return;
            clearTimeout(this.closeTimer);
            clearTimeout(this.openTimer);
            this.openTimer = setTimeout(() => this.openMega(item), this.openItem ? 0 : 120);
          });
          item.addEventListener('pointerleave', (e) => {
            if (e.pointerType !== 'mouse') return;
            clearTimeout(this.openTimer);
            this.closeTimer = setTimeout(() => this.closeMega(item), 220);
          });
        }

        link.addEventListener('click', (e) => {
          // Touch / click mode: first tap opens, second tap follows the link.
          if (!desktopMQ.matches) return;
          if (this.openItem !== item) {
            e.preventDefault();
            this.openMega(item);
          } else if (this.trigger === 'click') {
            // allow navigation on second click
          }
        });

        link.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowDown' || ((e.key === ' ' || e.key === 'Spacebar') && this.openItem !== item)) {
            e.preventDefault();
            this.openMega(item);
            const first = panel.querySelector('a');
            if (first) first.focus();
          }
        });

        panel.addEventListener('keydown', (e) => {
          const links = [...panel.querySelectorAll('a')];
          const i = links.indexOf(document.activeElement);
          if (e.key === 'ArrowDown' && i > -1) {
            e.preventDefault();
            links[Math.min(i + 1, links.length - 1)].focus();
          } else if (e.key === 'ArrowUp' && i > -1) {
            e.preventDefault();
            if (i === 0) link.focus();
            else links[i - 1].focus();
          }
        });

        item.addEventListener('focusout', (e) => {
          if (!item.contains(e.relatedTarget)) this.closeMega(item);
        });
      });
    }

    openMega(item) {
      if (this.openItem && this.openItem !== item) this.closeMega(this.openItem, true);
      this.openItem = item;
      item.classList.add('is-open');
      this.classList.add('bz-header--mega-open');
      const link = item.querySelector('.bz-nav__link');
      if (link) link.setAttribute('aria-expanded', 'true');
      const panel = item.querySelector('[data-bz-mega]');
      if (panel && window.BZ) window.BZ.observeReveal(panel);
    }

    closeMega(item, instant) {
      const target = item || this.openItem;
      if (!target) return;
      target.classList.remove('is-open');
      const link = target.querySelector('.bz-nav__link');
      if (link) link.setAttribute('aria-expanded', 'false');
      if (this.openItem === target) this.openItem = null;
      if (!this.openItem) this.classList.remove('bz-header--mega-open');
      if (instant) target.classList.add('is-instant');
      requestAnimationFrame(() => target.classList.remove('is-instant'));
    }

    onDocClick(e) {
      if (this.openItem && !this.openItem.contains(e.target)) this.closeMega();
    }

    onKey(e) {
      if (e.key === 'Escape' && this.openItem) {
        const link = this.openItem.querySelector('.bz-nav__link');
        this.closeMega();
        if (link) link.focus();
      }
    }
  }
  if (!customElements.get('bz-header')) customElements.define('bz-header', BzHeader);

  /* ================= Search overlay ================= */
  const RECENT_KEY = 'bz:recent-searches';

  class BzSearch extends HTMLElement {
    connectedCallback() {
      try {
        this.config = JSON.parse(this.querySelector('[data-bz-search-config]').textContent);
      } catch (e) {
        this.config = { keywords: [], labels: {}, links: [] };
      }
      this.input = document.getElementById('BzSearchInput');
      if (!this.input) return;
      this.form = this.input.closest('form');
      this.slot = this.form.parentElement;
      this.inHeader = !this.contains(this.form);
      this.classList.toggle('bz-search--bar', this.inHeader);
      this.top = this.querySelector('.bz-search__top');
      this.results = this.querySelector('[data-bz-results]');
      this.idle = this.querySelector('[data-bz-idle]');
      this.typed = this.form.querySelector('[data-bz-typed]');
      this.clearBtn = this.form.querySelector('[data-bz-clear]');
      this.viewAll = this.querySelector('[data-bz-view-all]');
      this.cache = new Map();
      this.limit = Number(this.dataset.limit) || 3;
      this.activeIndex = -1;

      document.addEventListener('click', (e) => {
        const opener = e.target.closest('[data-bz-search-open]');
        if (opener) {
          e.preventDefault();
          const drawer = opener.closest('.bz-drawer');
          if (drawer && window.BZ) window.BZ.closeDrawer(drawer);
          this.open(opener);
        }
      });
      this.querySelectorAll('[data-bz-search-close]').forEach((el) => el.addEventListener('click', () => this.close()));
      this.addEventListener('keydown', (e) => this.onKeydown(e));
      if (this.inHeader) {
        this.input.addEventListener('keydown', (e) => this.onKeydown(e));
        this.input.addEventListener('focus', () => this.open(this.input));
        this.input.addEventListener('click', () => this.open(this.input));
      }

      this.input.addEventListener('input', () => this.onInput());
      this.input.addEventListener('focus', () => { this.classList.add('is-focused'); this.form.classList.add('is-focused'); });
      this.input.addEventListener('blur', () => { this.classList.remove('is-focused'); this.form.classList.remove('is-focused'); });
      this.form.addEventListener('reset', () => {
        setTimeout(() => {
          this.onInput();
          this.input.focus();
        });
      });
      this.form.addEventListener('submit', (e) => {
        const term = this.input.value.trim();
        if (!term) {
          e.preventDefault();
          return;
        }
        this.saveRecent(term);
      });

      const clearRecent = this.querySelector('[data-bz-clear-recent]');
      if (clearRecent)
        clearRecent.addEventListener('click', () => {
          try {
            localStorage.removeItem(RECENT_KEY);
          } catch (e) {}
          this.renderRecent();
        });

      this.initVoice();
      this.startTyping();
      const prefilled = this.input.value.length > 0;
      this.classList.toggle('has-value', prefilled);
      this.form.classList.toggle('has-value', prefilled);
      if (this.clearBtn) this.clearBtn.hidden = !prefilled;
      this.renderRecent();
    }

    /* ---- open / close ---- */
    open(opener) {
      if (!this.hidden) return;
      this.opener = opener === this.input ? null : opener;
      this.hidden = false;
      if (this.inHeader && (!desktopMQ.matches || this.slot.offsetParent === null) && this.top) this.top.after(this.form);
      this.form.classList.add('is-open');
      document.documentElement.classList.add('bz-search-open');
      if (!desktopMQ.matches) document.documentElement.classList.add('bz-lock');
      document.querySelectorAll('[data-bz-search-open][aria-controls="BzSearch"]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
      requestAnimationFrame(() => {
        this.classList.add('is-open');
        this.input.focus({ preventScroll: true });
      });
      this.injectPopular();
      this.renderRecent();
      const header = this.closest('bz-header');
      if (header) header.closeMega();
    }

    close() {
      if (this.hidden) return;
      this.classList.remove('is-open');
      this.form.classList.remove('is-open');
      if (this.inHeader && this.form.parentElement !== this.slot) this.slot.appendChild(this.form);
      if (this.inHeader && document.activeElement === this.input) this.input.blur();
      document.documentElement.classList.remove('bz-search-open', 'bz-lock');
      document.querySelectorAll('[data-bz-search-open][aria-controls="BzSearch"]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
      const finish = () => {
        this.hidden = true;
      };
      if (reduceMotion) finish();
      else setTimeout(finish, 280);
      if (this.opener && this.opener.focus) this.opener.focus({ preventScroll: true });
    }

    injectPopular() {
      const host = this.querySelector('[data-bz-popular]');
      const tpl = this.querySelector('[data-bz-popular-template]');
      if (!host || !tpl || host.childElementCount) return;
      host.appendChild(tpl.content.cloneNode(true));
      if (window.BZ) window.BZ.init(host);
    }

    /* ---- animated placeholder ---- */
    startTyping() {
      const words = (this.config.keywords || []).filter(Boolean);
      const hosts = [this.typed, ...document.querySelectorAll('[data-bz-typed-host]')].filter(Boolean);
      if (!words.length) return;
      if (reduceMotion) {
        hosts.forEach((h) => this.setTyped(h, words[0]));
        return;
      }
      const hold = Number(this.dataset.speed) || 3000;
      let w = 0;
      let c = 0;
      let deleting = false;
      const tick = () => {
        const word = words[w];
        c += deleting ? -1 : 1;
        hosts.forEach((h) => this.setTyped(h, word.slice(0, c)));
        let delay = deleting ? 35 : 70;
        if (!deleting && c >= word.length) {
          deleting = true;
          delay = hold;
        } else if (deleting && c <= 0) {
          deleting = false;
          w = (w + 1) % words.length;
          delay = 300;
        }
        this.typeTimer = setTimeout(tick, delay);
      };
      tick();
    }

    setTyped(host, text) {
      host.textContent = text;
    }

    /* ---- recent searches ---- */
    readRecent() {
      try {
        const v = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
        return Array.isArray(v) ? v : [];
      } catch (e) {
        return [];
      }
    }

    saveRecent(term) {
      if (this.dataset.recent !== 'true') return;
      const list = this.readRecent().filter((t) => t.toLowerCase() !== term.toLowerCase());
      list.unshift(term);
      try {
        localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 8)));
      } catch (e) {}
    }

    renderRecent() {
      const wrap = this.querySelector('[data-bz-recent-wrap]');
      const list = this.querySelector('[data-bz-recent]');
      if (!wrap || !list) return;
      const items = this.dataset.recent === 'true' ? this.readRecent().slice(0, 5) : [];
      wrap.hidden = items.length === 0;
      list.innerHTML = '';
      items.forEach((term) => {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.className = 'bz-search__term';
        a.href = `${window.routes?.search_url || '/search'}?q=${encodeURIComponent(term)}&options%5Bprefix%5D=last`;
        a.setAttribute('data-bz-option', '');
        a.setAttribute('role', 'option');
        a.innerHTML = '<svg class="bz-icon" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8.5" fill="none" stroke="currentColor" stroke-width="1.4"/><path d="M12 7.5V12l3 2" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>';
        const span = document.createElement('span');
        span.textContent = term;
        a.appendChild(span);
        li.appendChild(a);
        list.appendChild(li);
      });
    }

    /* ---- voice search ---- */
    initVoice() {
      const btn = this.form.querySelector('[data-bz-voice]');
      const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
      if (!btn || !SR) return;
      btn.hidden = false;
      btn.addEventListener('click', () => {
        const rec = new SR();
        rec.lang = document.documentElement.lang || 'en-IN';
        rec.interimResults = true;
        btn.classList.add('is-listening');
        rec.onresult = (e) => {
          const text = [...e.results].map((r) => r[0].transcript).join('');
          this.input.value = text;
          this.onInput();
        };
        rec.onend = () => btn.classList.remove('is-listening');
        rec.onerror = () => btn.classList.remove('is-listening');
        rec.start();
      });
    }

    /* ---- live results ---- */
    onInput() {
      const term = this.input.value.trim();
      const has = term.length > 0;
      this.classList.toggle('has-value', this.input.value.length > 0);
      this.form.classList.toggle('has-value', this.input.value.length > 0);
      if (this.clearBtn) this.clearBtn.hidden = !has;
      this.activeIndex = -1;

      if (this.viewAll) {
        this.viewAll.hidden = !has;
        this.viewAll.querySelector('[data-bz-term]').textContent = term;
        this.viewAll.href = `${window.routes?.search_url || '/search'}?q=${encodeURIComponent(term)}&options%5Bprefix%5D=last`;
      }

      if (!has) {
        this.results.hidden = true;
        this.idle.hidden = false;
        this.input.setAttribute('aria-expanded', 'false');
        return;
      }
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => this.fetchResults(term), 180);
    }

    async fetchResults(term) {
      if (this.dataset.predictive !== 'true') {
        this.renderHTML(`<div class="bz-ps"><div class="bz-ps__col bz-ps__col--suggest"><p class="bz-eyebrow" data-bz-label="smart"></p><ul class="bz-search__terms" role="list" data-bz-smart-host></ul></div></div>`, term);
        return;
      }
      const key = term.toLowerCase();
      if (this.cache.has(key)) {
        this.renderHTML(this.cache.get(key), term);
        this.fetchCount(term);
        return;
      }
      if (this.abort) this.abort.abort();
      this.abort = 'AbortController' in window ? new AbortController() : null;
      this.classList.add('is-loading');
      const params = new URLSearchParams({
        q: term,
        'resources[type]': 'query,collection,product,page,article',
        'resources[limit]': String(Math.max(this.limit, 3)),
        'resources[limit_scope]': 'each',
        'resources[options][prefix]': 'last',
        'resources[options][unavailable_products]': 'last',
        section_id: 'bz-predictive-search',
      });
      const base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
      try {
        const res = await fetch(`${base}?${params}`, this.abort ? { signal: this.abort.signal } : {});
        if (!res.ok) throw new Error(res.status);
        const text = await res.text();
        const html = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-bz-ps]');
        const markup = html ? html.outerHTML : '';
        this.cache.set(key, markup);
        if (this.input.value.trim().toLowerCase() === key) {
          this.renderHTML(markup, term);
          this.fetchCount(term);
        }
      } catch (e) {
        if (e.name !== 'AbortError') this.renderHTML('', term);
      } finally {
        this.classList.remove('is-loading');
      }
    }

    async fetchCount(term) {
      const key = `count:${term.toLowerCase()}`;
      const apply = (n) => {
        const el = this.results.querySelector('[data-bz-count]');
        if (el && n !== null && n !== '') el.textContent = `(${n})`;
      };
      if (this.cache.has(key)) return apply(this.cache.get(key));
      try {
        const url = `${window.routes?.search_url || '/search'}?q=${encodeURIComponent(term)}&type=product&options%5Bprefix%5D=last&section_id=bz-search-count`;
        const res = await fetch(url);
        if (!res.ok) return;
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const n = doc.querySelector('[data-count]');
        if (n) {
          this.cache.set(key, n.textContent.trim());
          if (this.input.value.trim().toLowerCase() === term.toLowerCase()) apply(n.textContent.trim());
        }
      } catch (e) {}
    }

    renderHTML(markup, term) {
      const labels = this.config.labels || {};
      this.results.innerHTML = markup || `<div class="bz-ps bz-ps--empty"><div class="bz-ps__col bz-ps__col--suggest"><p class="bz-eyebrow" data-bz-label="smart"></p><ul class="bz-search__terms" role="list" data-bz-smart-host></ul></div><div class="bz-ps__col bz-ps__col--products"><p class="bz-ps__none" data-bz-label="empty"></p></div></div>`;
      this.results.querySelectorAll('[data-bz-label]').forEach((el) => {
        el.textContent = labels[el.dataset.bzLabel] || '';
      });
      this.renderSmart(term);
      this.idle.hidden = true;
      this.results.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
      this.results.querySelectorAll('[data-bz-option]').forEach((el, i) => (el.id = `BzOpt-${i}`));
      if (window.BZ) window.BZ.init(this.results);
    }

    /* Smart (intent-aware) suggestions: price intent + category matches from the menu */
    renderSmart(term) {
      const host = this.results.querySelector('[data-bz-smart-host]');
      if (!host) return;
      const labels = this.config.labels || {};
      const q = term.toLowerCase();
      const out = [];
      const searchUrl = window.routes?.search_url || '/search';

      const price = q.match(/(?:under|below|less than|upto|up to|within|max|<)\s*(?:rs\.?|inr|₹)?\s*(\d{2,6})/);
      if (price) {
        const rest = q.replace(price[0], '').trim() || '';
        const params = new URLSearchParams({ q: rest || '*', type: 'product', 'filter.v.price.lte': price[1], 'options[prefix]': 'last' });
        out.push({ t: `${rest ? rest + ' · ' : ''}${labels.under || 'Under'} ₹${Number(price[1]).toLocaleString('en-IN')}`, u: `${searchUrl}?${params}` });
      }

      const words = q.split(/[^a-z0-9ऀ-ॿ]+/).filter((w) => w.length >= 3);
      const stem = (w) => w.replace(/(ies)$/, 'y').replace(/(es|s)$/, '');
      const seen = new Set();
      (this.config.links || []).forEach((l) => {
        if (out.length >= 4) return;
        const title = (l.t || '').toLowerCase();
        const hit = words.some((w) => title.includes(stem(w)) || stem(title).includes(stem(w)));
        if (hit && !seen.has(l.u)) {
          seen.add(l.u);
          out.push({ t: l.t, u: l.u, collection: true });
        }
      });

      if (!out.length) return;
      const frag = document.createDocumentFragment();
      const head = document.createElement('li');
      head.className = 'bz-search__smart-head';
      head.innerHTML = `<svg class="bz-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.5c.6 4.6 2.9 6.9 7.5 7.5-4.6.6-6.9 2.9-7.5 7.5-.6-4.6-2.9-6.9-7.5-7.5 4.6-.6 6.9-2.9 7.5-7.5Z" fill="currentColor"/></svg>`;
      const headText = document.createElement('span');
      headText.textContent = labels.smart || 'Smart suggestions';
      head.appendChild(headText);
      frag.appendChild(head);
      out.forEach((s) => {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = s.u;
        a.className = 'bz-search__term bz-search__term--smart';
        a.setAttribute('data-bz-option', '');
        a.setAttribute('role', 'option');
        const span = document.createElement('span');
        span.textContent = s.t;
        a.appendChild(span);
        a.insertAdjacentHTML('beforeend', '<svg class="bz-arrow" viewBox="0 0 22 10" aria-hidden="true"><path d="M0 5h20.5M16.5 1l4 4-4 4" fill="none" stroke="currentColor" stroke-width="1.2"/></svg>');
        li.appendChild(a);
        frag.appendChild(li);
      });
      host.appendChild(frag);
    }

    /* ---- keyboard ---- */
    onKeydown(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        this.close();
        return;
      }
      if (e.key === 'Tab' && (!this.inHeader || !desktopMQ.matches)) {
        // simple focus trap
        const focusables = [...this.querySelectorAll('a[href], button:not([hidden]), input:not([type="hidden"])')].filter((el) => el.offsetParent !== null);
        if (!focusables.length) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
        return;
      }
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Enter') return;
      const scope = this.results.hidden ? this.idle : this.results;
      const options = [...scope.querySelectorAll('[data-bz-option]')].filter((el) => el.offsetParent !== null);
      if (!options.length) return;
      if (e.key === 'Enter') {
        if (this.activeIndex > -1 && options[this.activeIndex]) {
          e.preventDefault();
          if (this.input.value.trim()) this.saveRecent(this.input.value.trim());
          options[this.activeIndex].click();
        }
        return;
      }
      e.preventDefault();
      this.activeIndex = e.key === 'ArrowDown' ? Math.min(this.activeIndex + 1, options.length - 1) : Math.max(this.activeIndex - 1, -1);
      options.forEach((o, i) => {
        o.classList.toggle('is-active', i === this.activeIndex);
        o.setAttribute('aria-selected', i === this.activeIndex ? 'true' : 'false');
      });
      if (this.activeIndex > -1) {
        const active = options[this.activeIndex];
        this.input.setAttribute('aria-activedescendant', active.id || '');
        active.scrollIntoView({ block: 'nearest' });
      } else {
        this.input.removeAttribute('aria-activedescendant');
      }
    }
  }
  if (!customElements.get('bz-search')) customElements.define('bz-search', BzSearch);
})();
